import {Button, Col, Row} from 'antd';
import {ColumnsType} from 'antd/lib/table/Table';
import {RiEdit2Line} from 'react-icons/ri';
import {useNavigate} from 'react-router-dom';
import IntlMessages from '../../../../../domain/utility/IntlMessages';
import {ProductTagProductsDto} from '../../../../../shared/services/product-tag/dtos/product-tag-products-dto';
import {useLocaleContext} from 'src/domain/utility/AppContextProvider/LocaleContextProvide';

const TableColumn = (): ColumnsType<any> => {
  const navigate = useNavigate();

  const {locale}: any = useLocaleContext();
  return [
    {
      title: <IntlMessages id='productTags.edit.productName' />,
      dataIndex: 'Name',
      key: 'Name',
      width: '80%',
      render: (value: string, record: ProductTagProductsDto) => {
        return (
          record?.Locales?.find((item) => item.LanguageId === locale.code)
            ?.LocaleValue ?? value
        );
      },
    },
    {
      title: <IntlMessages id='common.Action' />,
      key: 'action',
      render: (value, record: ProductTagProductsDto, index) => {
        return (
          <Row justify='center'>
            <Col>
              <Button
                onClick={() => navigate(`/catalog/products/edit/${record.Id}`)}
                type='primary'
                icon={<RiEdit2Line className='add-button-icon' />}
                size='small'
                className='add-button'>
                <IntlMessages id='common.edit' />
              </Button>
            </Col>
          </Row>
        );
      },
      className: 'col-actions',
      width: 120,
      ellipsis: true,
    },
  ];
};

export default TableColumn;
